import { defineAction } from 'redux-define';
import { TheApp, LOADING, ERROR, SUCCESS, FILTER } from '../../constants/stateConstants';

export const centers = defineAction('centers', [LOADING, ERROR, SUCCESS], TheApp);
export const LIST = defineAction('LIST', [ FILTER, LOADING, ERROR, SUCCESS, 'SYNC'], centers);
export const GET = defineAction('GET', [ LOADING, ERROR, SUCCESS], centers);
export const SYNC = defineAction('SYNC', [ LOADING, ERROR, SUCCESS], centers);
export const CREATE = defineAction('CREATE', [ LOADING, ERROR, SUCCESS], centers);
export const UPDATE = defineAction('UPDATE', [ LOADING, ERROR, SUCCESS], centers);
export const DELETE = defineAction('DELETE', [ LOADING, ERROR, SUCCESS], centers);